<template>
  <div class="container">
    <v-breadcrumbs>
      <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
        >Home</v-breadcrumbs-item
      >
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item
        :exact="true"
        :to="{ name: 'studentRequirementSubmission', params: {} }"
      >
        Student Submissions
      </v-breadcrumbs-item>
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item disabled> Waive Requirement </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-card class="pb-8">
      <v-card-title>Waive Student Requirement</v-card-title>
      <v-card-text>
        <div class="text-center" v-if="student">
          Student: {{ student.fullName }}
        </div>

        <div class="text-subtitle-2 my-2">
          <span
            >Waiving
            {{
              requirements && requirements.length > 1
                ? "requirements"
                : "requirement"
            }}:
          </span>
        </div>

        <div v-for="requirement in requirements" :key="requirement.id">
          {{ requirement.name }}
          <span v-if="requirement.type == 'Vaccination'">
            {{ getDoses(requirement.id) }}
          </span>
        </div>

        <v-textarea
          class="my-2"
          v-model="notes"
          :auto-grow="true"
          :rows="3"
          outline
          placeholder="Please enter a reason for this waiver"
          outlined
          hide-details
          dense
        />
      </v-card-text>
      <div class="mx-md-4">
        <image-upload maxSize="52428800" v-model="files" />
      </div>

      <v-divider class="my-6" />

      <v-card-actions class="justify-space-between ma-2">
        <v-btn @click="goBack"> Back </v-btn>
        <v-btn :loading="isAppLoading" :disabled="isAppLoading" @click="handleSubmit" color="primary"
          >Submit</v-btn
        >
        <span></span>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { getStudent } from "@/services/student";
import { getRequirements } from "@/services/requirement";
import { mapActions, mapGetters } from "vuex";

export default {
  data: () => ({
    notes: null,
    student: null,
    requirementIds: [],
    requirements: [],
    requirement2Dose: null,
    files: [],
  }),
  computed: {
    ...mapGetters("navigation", ["isAppLoading"]),
  },
  created() {
    this.$emit("showParent", false);
    const studentId = this.$route.query.studentId;
    getStudent(studentId).then((response) => {
      this.student = response.data;
    });
    const requirements = this.$route.query.requirements;
    this.parseRequirementsParam(requirements);
    this.fetchRequirements();
  },
  methods: {
    ...mapActions("messages", [
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage",
    ]),
    parseRequirementsParam(requirements) {
      const ids = new Set();
      this.requirement2Dose = new Map();
      if (requirements) {
        String(requirements)
          .split(",")
          .map((r) => {
            const requireIdDose = r.split("_");
            const id = parseInt(requireIdDose[0]);
            const dose = requireIdDose.length == 2 ? requireIdDose[1] : null;
            ids.add(id);
            this.requirementIds = Array.from(ids);

            if (dose) {
              const doseInfo = { dose, vaccinationDate: null };
              if (this.requirement2Dose.get(id)) {
                this.requirement2Dose.get(id).push(doseInfo);
              } else {
                this.requirement2Dose.set(id, [doseInfo]);
              }
            }
          });
      }
    },
    fetchRequirements() {
      const ids = this.requirementIds.join(",");
      getRequirements(ids).then((response) => {
        this.requirements = response.data;
      });
    },
    getDoses(requirementId) {
      const doses = this.requirement2Dose.get(requirementId);
      if (doses && doses.length > 1) {
        return `Doses ${doses.map((d) => d.dose).join(",")}`;
      } else if (doses && doses.length == 1) {
        return `Dose ${doses[0].dose}`;
      } else {
        return "";
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    backToStudentView() {
      const id = this.studentId ? this.studentId : this.student.id;
      this.$router.push({ name: "studentView", params: { id } });
    },
    async uploadFiles(submissionId, files) {
      if (files && files.length > 0) {
        var formData = new FormData();
        formData.append("studentId", this.student.id);
        for (const f of files) {
          formData.append("files", f, f.name);
        }

        this.addMessage("Uploading images...");
        return await this.$axios
          .post(
            `/studentRequirementSubmission/upload/${submissionId}`,
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          )
          .then((resp) => {
            const savedFiles = resp.data;
            const uploadCount = savedFiles.files ? savedFiles.files.length : "";
            this.addSuccessMessage(
              `Uploaded ${uploadCount} files successfully`
            );
          });
      }
    },
    handleSubmit() {
      const data = {
        studentId: this.student.id,
        requirements: [],
        submissionMethod: null,
        state: "completed",
        notes: this.notes,
        attachments: [],
      };
      this.requirements.forEach((r) => {
        const doses = this.requirement2Dose.get(r.id);
        if (doses && doses.length > 0) {
          doses.forEach((d) => {
            data.requirements.push({
              requirementId: r.id,
              forDoseNumber: d.dose,
            });
          });
        } else {
          data.requirements.push({
            requirementId: r.id,
          });
        }
      });
      this.$axios
        .post("/studentRequirementSubmission/waive", data)
        .then(async (response) => {
          const submissionId = response.data;
          if (this.files) {
            this.addMessage("Uploading attachment, please wait...");
            await this.uploadFiles(submissionId, this.files)
              .then(() => {
                this.addSuccessMessage("Submission was updated successfully");
                this.backToStudentView();
              })
              .catch(() => {
                this.addErrorMessage("Error uploading attachments");
              });
          } else {
            this.addSuccessMessage("Submission was updated successfully");
          }
        })
        .catch(() => {
          this.addErrorMessage(
            "Error submitting requirement, please try again later"
          );
        });
    },
  },
};
</script>

<style>
</style>